import React from 'react';
import T from 'prop-types';

import Modal from './Modal';
import Button from './Buttons/Button';

const DeleteModal = ({
  open,
  buttonSize,
  confirmPreHeading,
  confirmMessage,
  confirmButtonText = 'Delete',
  confirmButtonIconClass = 'hicon-delete-thin',
  closeButtonIconClass = 'hidden',
  deleteUrl,
  onClose,
  onDelete,
}) => (
  <Modal
    open={open}
    size="xs"
    closeButtonIconClass={closeButtonIconClass}
    modalClassName="delete-modal"
    onClose={onClose}
  >
    {confirmPreHeading && <p className="delete-modal-heading">{confirmPreHeading}</p>}
    <h2 className="delete-modal-title">{confirmMessage}</h2>

    <div className="delete-modal-buttons">
      <Button
        size={buttonSize}
        variant="secondary"
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        size={buttonSize}
        variant="danger"
        href={deleteUrl}
        onClick={e => onDelete && onDelete(e)}
      >
        <span className={confirmButtonIconClass} />
        {confirmButtonText}
      </Button>
    </div>
  </Modal>
);

DeleteModal.propTypes = {
  open: T.bool.isRequired,
  buttonSize: T.oneOf(['sm', 'lg']),
  confirmMessage: T.oneOfType([T.string, T.element]).isRequired,
  confirmButtonText: T.string,
  confirmButtonIconClass: T.string,
  closeButtonIconClass: T.string,
  confirmPreHeading: T.string,
  deleteUrl: T.string,
  onDelete: T.func,
  onClose: T.func.isRequired,
};

export default DeleteModal;
